import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  isAllowedSignatureOrigin,
  parsePurchaseCompleteMessage,
} from '../purchase-complete.contract';
import { usePurchaseCompleteStore } from '../store/purchase-complete.store';
import { activeSubscriptionQueryKey } from './use-active-subscription';
import { useAuthStore } from '@/state/store/auth';

export const usePurchaseCompleteListener = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (!isAllowedSignatureOrigin(event.origin)) return;
      const expected = usePurchaseCompleteStore.getState().expectedCorrelationId;
      if (!expected) return;

      const payload = parsePurchaseCompleteMessage(event.data);
      if (!payload) return;
      if (payload.correlationId !== expected) return;

      usePurchaseCompleteStore.getState().accept(payload);
      const { userId, sigOrgId } = useAuthStore.getState();
      void queryClient.invalidateQueries({
        queryKey: activeSubscriptionQueryKey(userId, sigOrgId),
      });
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [queryClient]);
};
